import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { TemplateDataTable } from "./TemplateDataTable";
import { HOST_URL } from "../api/Api";
import Axios from "../../../axios/Axios";
import styles from "./VoiceTemplateNew.module.css";

const VoiceTemplate = () => {
  const login = JSON.parse(localStorage.getItem("login"));
  const userId = login?.user?.userId;
  const token = login?.token;

  /* FETCH DATA (same API as old) */
  const fetchVoiceTemplates = useCallback(
    async ({ page, limit, search }) => {
      const payload = {
        user_id: userId,
        method: search ? "search" : "retrieve",
        keyword: search || null,
        token,
      };

      const response = await Axios.post(
        `${HOST_URL}/voice_template.php`,
        payload
      );

      if (!response?.data?.success) {
        return { data: [], total: 0 };
      }

      const rows = response.data.data || [];
      const start = (page - 1) * limit;

      return {
        data: rows.slice(start, start + limit),
        total: rows.length,
      };
    },
    [userId, token]
  );

  /* COLUMNS = EXACT OLD STRUCTURE */
  const voiceColumns = [
    {
      key: "id",
      label: "VID",
      width: "90px",
      className: styles.cell,
      render: (row) => row.id,
    },
    {
      key: "template_name",
      label: "Name",
      width: "220px",
      className: styles.cell,
      render: (row) => row.template_name,
    },
    {
      key: "content",
      label: "Voice Content",
      width: "320px",
      className: styles.cell,
      render: (row) => (
        <div className={styles.truncate} title={row.content}>
          {row.content}
        </div>
      ),
    },
    {
      key: "is_active",
      label: "Status",
      width: "140px",
      className: styles.cell,
      render: (row) =>
        row.is_active === 1 ? (
          <span className={`${styles.status} ${styles.active}`}>
            Active
          </span>
        ) : (
          <span className={`${styles.status} ${styles.inactive}`}>
            Inactive
          </span>
        ),
    },
    {
      key: "created",
      label: "Create Date",
      width: "160px",
      className: styles.cell,
      render: (row) => row.created,
    },
    {
      key: "action",
      label: "Action",
      width: "100px",
      className: styles.cell,
      render: (row) => (
        <Link to={`/dashboard/voice-template/edit/${row.id}`}>
          <span className={styles.editBtn}>
            <FontAwesomeIcon icon={faEdit} />
          </span>
        </Link>
      ),
    },
  ];

  return (
    <TemplateDataTable
      columns={voiceColumns}
      fetchData={fetchVoiceTemplates}
      pageSize={5}
      flags={{ search: true, pagination: true }}
      searchPlaceholder="Search Voice templates"
    />
  );
};

export default VoiceTemplate;
